export const ROLE_LABELS = {
  clientes: 'Cliente',
  proveedores: 'Proveedor',
  honorarios: 'Prestador de honorarios',
  colaboradores: 'Colaborador',
};

export const ROLE_CONFIG = {
  clientes: {
    title: 'Clientes',
    subject: 'cliente',
    book: 'Libro de ventas',
    amountLabel: 'Facturado',
    masterLabel: 'Ficha CRM',
    emptyText: 'Sin clientes. Importa el Libro de ventas o registra organizaciones como Cliente en el CRM.',
  },
  proveedores: {
    title: 'Proveedores',
    subject: 'proveedor',
    book: 'Libro de compras',
    amountLabel: 'Comprado',
    masterLabel: 'Ficha proveedor',
    emptyText: 'Sin proveedores. Importa el Libro de compras o crea proveedores en Adquisiciones.',
  },
  honorarios: {
    title: 'Prestadores de honorarios',
    subject: 'prestador',
    book: 'Libro de honorarios',
    amountLabel: 'Honorarios',
    masterLabel: '',
    emptyText: 'Sin prestadores de honorarios. Registra boletas en el Libro de honorarios de Contabilidad.',
  },
  colaboradores: {
    title: 'Colaboradores',
    subject: 'colaborador',
    book: 'Libro de remuneraciones',
    amountLabel: 'Remuneraciones',
    masterLabel: 'Ficha colaborador',
    emptyText: 'Sin colaboradores. Regístralos en Recursos Humanos o carga el Libro de remuneraciones.',
  },
};
